<template>
  <div class='StoryAccess'>
    <button class="btn-desktop" @click="Empresa.modelo === 'Modelo 03' ? $router.push('/site') : $router.push('/loja')" @mouseenter="anime(true)" @mouseleave="anime(false)">
      <div class="text">{{ Empresa.modelo === 'Modelo 03' ? 'MAIS IMÓVEIS' : 'MAIS PRODUTOS' }}</div>
      <bag-icon :color="color" :tam="tam"/>
    </button>
    <button class="btn-mobile" @click="Empresa.modelo === 'Modelo 03' ? $router.push('/site') : $router.push('/loja')">
      <div class="text">{{ Empresa.modelo === 'Modelo 03' ? 'MAIS IMÓVEIS' : 'MAIS PRODUTOS' }}</div>
      <bag-icon :color="color" :tam="tam"/>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { icons } from '../icons'
export default {
  name: 'StoryAccess',
  components: { ...icons },
  computed: {
    ...mapGetters(['Empresa'])
  },
  data () {
    return {
      color: '#FFFFFF',
      tam: '25px'
    }
  },
  methods: {
    anime (data) {
      if(data) {
        this.color = '#4ec95c'
        this.tam = '23px'
      }
      else {
        this.color = '#FFFFFF'
        this.tam = '25px'
      }
    }
  }
}
</script>

<style scoped>
.StoryAccess {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 20%;
}

.text {
  padding-right: 3%;
}

button {
  width: 15%;
  height: max-content;
  margin-top: 2.5%;
  padding: 1%;
  border: 0;
  border-radius: 10px;
  color: #FFFFFF;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  animation: startOff 0.2s forwards;
  border: 3px solid #4ec95c;
}

.btn-desktop:hover {
  animation: startOn 0.2s forwards;
}

@keyframes startOn {
  0% {
    width: 15%;
    padding: 1%;
    margin-top: 2.5%;
    font-size: 14px;
    color: #FFFFFF;
  }
  100% {
    width: 14%;
    padding: 0.8%;
    margin-top: 2.7%;
    font-size: 12px;
    color: #4ec95c;
  }
}
@keyframes startOff {
  0% {
    width: 14%;
    padding: 0.8%;
    margin-top: 2.7%;
    font-size: 12px;
    color: #4ec95c;
  }
  100% {
    width: 15%;
    padding: 1%;
    margin-top: 2.5%;
    font-size: 14px;
    color: #FFFFFF;
  }
}

@media (max-width: 500px) {
  @keyframes startOff {
    0% {
      width: 14%;
      padding: 0.8%;
      margin-top: 2.7%;
      font-size: 12px;
      color: #4ec95c;
    }
    100% {
      width: 60%;
      padding: 3%;
      margin-top: 2.5%;
      font-size: 18px;
      color: #FFFFFF;
    }
  }
}
@media screen and (min-width: 500px) {
  .btn-mobile {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .btn-desktop {
    display: none;
  }
}
</style>
